import { useUserAuth } from '../providers/auth';

const UserRole = {
  ADMIN: 'admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
  LIMITED_VIEW: 'limited_view',
};

export const usePermissions = () => {
  const { user } = useUserAuth();
  const role = user?.organizationMembership?.role;

  const canEdit = role === UserRole.ADMIN || role === UserRole.EDITOR;
  const isOrgAdmin = role === UserRole.ADMIN;
  const canCreateEvents = canEdit;
  const canViewInbox = canEdit;
  return {
    canEdit,
    isOrgAdmin,
    canCreateEvents,
    canViewInbox,
  };
};
